import { showAlert } from "../../store/alertSlice";
import { AppDispatch } from "../../store/store";

interface ErrorResponse {
  status?: number;
  message?: string;
  data?: any;
  details?: { message: string }[];
}

export const handleApiError = (dispatch: AppDispatch, error: any) => {
  const errorResponse: ErrorResponse = error?.error || {};
  const { message = "An unexpected error occurred", details = [] } = errorResponse;
  const detailedMessage = details.length
  ? `${details.map((detail) => detail.message).join(", ")}`
  : message;
  dispatch(showAlert({ message: detailedMessage, type: 'error' }));
};
